import * as Sentry from '@sentry/nextjs';

const oneLinkURL = 'https://duet.onelink.me/GBnZ';
const mediaSource = { keys: ['pid'], defaultValue: 'website' };
const campaign = { keys: ['c'] };
const af_c_id = { paramKey: 'af_c_id', keys: ['af_c_id'] };
const adSet = { keys: ['af_adset'] };
const af_adset_id = { paramKey: 'af_adset_id', keys: ['af_adset_id'] };
const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };

// 生成OneLink URL
const generateOneLinkURL = (): string => {
  try {
    if (!window.AF_SMART_SCRIPT) {
      return 'https://duet.onelink.me/GBnZ/t3682sma';
    }

    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL,
      afParameters: {
        mediaSource,
        campaign,
        afCustom: [af_c_id, af_adset_id, custom_ss_ui],
        adSet,
      },
    });
    Sentry.captureMessage(JSON.stringify(result), 'debug');

    if (result && result.clickURL) {
      return result.clickURL;
    } else {
      return 'https://duet.onelink.me/GBnZ/t3682sma';
    }
  } catch (error) {
    Sentry.captureException(error);
    return 'https://duet.onelink.me/GBnZ/t3682sma';
  }
};

// 监听脚本加载完成并立即更新所有OneLink
export const initializeOneLinkOnLoad = (): void => {
  if (typeof window === 'undefined') return;

  const updateAllOneLinks = () => {
    const oneLinkURL = generateOneLinkURL();

    // 更新所有带有特定href的链接
    const links = document.querySelectorAll('a[href*="duet.onelink.me"]');
    links.forEach((link) => {
      if (link.getAttribute('href')?.includes('duet.onelink.me')) {
        link.setAttribute('href', oneLinkURL);
      }
    });
  };

  // 如果脚本已经加载，立即更新
  if (window.AF_SMART_SCRIPT) {
    updateAllOneLinks();
    return;
  }

  // 监听脚本加载完成
  const checkScriptLoaded = () => {
    if (window.AF_SMART_SCRIPT) {
      updateAllOneLinks();
    } else {
      setTimeout(checkScriptLoaded, 100);
    }
  };

  checkScriptLoaded();
};

// 尝试打开 Duet app，如果失败则跳转到 OneLink
export const openDuetAppOrOneLink = (deepLink: string = 'duet://payauth'): void => {
  const oneLinkURL = generateOneLinkURL();

  // 标记是否成功打开 app
  let appOpened = false;

  // 监听页面可见性变化，如果页面变为隐藏，说明 app 被打开了
  const handleVisibilityChange = () => {
    if (document.hidden) {
      appOpened = true;
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  // 尝试使用 iframe 打开 app（保持用户手势上下文）
  const now = Date.now();
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = deepLink;
  document.body.appendChild(iframe);

  // 设置超时检查，如果 2 秒后仍未打开 app，则跳转到 OneLink
  // 关键：在用户手势上下文中立即创建 a 标签，稍后触发点击
  const fallbackLink = document.createElement('a');
  fallbackLink.href = oneLinkURL;
  fallbackLink.style.display = 'none';
  document.body.appendChild(fallbackLink);

  const timeoutId = setTimeout(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);

    // 检查是否成功打开了 app
    console.log('appOpened', appOpened, document.hidden);
    if (!appOpened && !document.hidden) {
      console.log('Fallback to OneLink:', oneLinkURL);
      // 使用点击 a 标签而不是直接修改 location.href
      // 这样可以保持用户手势上下文
      fallbackLink.click();
    }

    // 清理
    setTimeout(() => {
      document.body.removeChild(iframe);
      document.body.removeChild(fallbackLink);
    }, 100);
  }, 2000);
};
